import { Component, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-attachment-view-dialog',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './attachment-view-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./attachment-view-dialog.component.scss'],
})
export class AttachmentViewDialogComponent implements OnDestroy {
  private dialogRef = inject<MatDialogRef<AttachmentViewDialogComponent>>(MatDialogRef);
  data = inject<{
    attachmentType: string | null;
    imageDataUrl: string | null;
    safeUrl: SafeResourceUrl | null;
    blobObjectUrl: string | null;
  }>(MAT_DIALOG_DATA);

  attachmentType: string | null;
  imageDataUrl: string | null;
  safeUrl: SafeResourceUrl | null;
  blobObjectUrl: string | null;

  constructor() {
    const data = this.data;

    this.attachmentType = data.attachmentType;
    this.imageDataUrl = data.imageDataUrl;
    this.safeUrl = data.safeUrl;
    this.blobObjectUrl = data.blobObjectUrl;
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.blobObjectUrl) {
      URL.revokeObjectURL(this.blobObjectUrl);
    }
  }
}